// import { Plane, Linkedin, Twitter, Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ccab85ca-bf95-4b72-aac4-cda44cdf7c03/artifacts/bzaxj2ee_Ozo-AeroCare%20%282%29.png";

const quickLinks = [
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Choose Us", href: "#why-us" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

const certs = ["ISO 9001:2015", "ISO 14001:2015"];

export default function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="bg-[#0C3A72] text-[#F7F4EC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="h-14 w-auto mb-4 inline-block bg-[#F7F4EC] rounded p-1.5">
              <img
                src={LOGO_URL}
                alt="OZO AeroCare"
                className="h-full w-auto"
              />
            </div>
            <p className="text-sm text-[#F7F4EC]/70 leading-relaxed mb-4">
              Indigenous aviation chemistry solutions. OEM-certified, independently tested, proudly manufactured in India.
            </p>
            <p className="text-sm text-[#F7F4EC]/50">
              A division of Unik Naturals, Bengaluru
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-medium mb-6">Navigation</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-sm text-[#F7F4EC]/70 hover:text-[#0077D1] transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Certifications */}
          {/* <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-medium mb-6">Certifications</h4>
            <ul className="space-y-3">
              {certs.map((cert) => (
                <li key={cert} className="cert-badge text-xs tracking-wider text-[#F7F4EC]/60">
                  {cert}
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact & Social */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-medium mb-6">Contact</h4>
            <div className="space-y-3 text-sm text-[#F7F4EC]/70 mb-8">
              <p>No. 54, DV Nagar</p>
              <p>Bengaluru, Karnataka 560016</p>
              <a href="tel:+917829117300" className="block hover:text-[#0077D1] transition-colors">
                +91 78291 17300
              </a>
              <a href="mailto:satyam.purohit@odofree.com" className="block hover:text-[#0077D1] transition-colors">
                satyam.purohit@odofree.com
              </a>
            </div>

            {/* Social Links
            <div className="flex gap-3">
              {[
                { icon: Linkedin, href: "#", label: "LinkedIn" },
                { icon: Twitter, href: "#", label: "Twitter" },
                { icon: Instagram, href: "#", label: "Instagram" },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  data-testid={`social-link-${social.label.toLowerCase()}`}
                  aria-label={social.label}
                  className="w-9 h-9 border border-[#F7F4EC]/20 flex items-center justify-center hover:border-[#0077D1] hover:bg-[#0077D1] transition-all duration-300"
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div> */}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#F7F4EC]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#F7F4EC]/50">
            &copy; {new Date().getFullYear()} Unik Naturals. All rights reserved.
          </p>
          <p className="text-xs text-[#F7F4EC]/50">
            Powering Tomorrow's Aviation with Indigenous Excellence
          </p>
        </div>
      </div>
    </footer>
  );
}
